import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { TranslocoDirective } from "@jsverse/transloco";
import { UnikoServiceTypes } from "src/app/services/payments-api.service";
import { ServiceCardComponent } from 'src/app/shared/components/service-card/service-card.component';
import Swiper from "swiper";
import { auctionServices, defaultServices } from "./services";

@Component({
  selector: 'app-property-services',
  templateUrl: './property-services.component.html',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, RouterLink, ServiceCardComponent]
})
export class PropertyServicesComponent implements OnInit {
  @Input() propertyCode: string | undefined;
  @Input() isAuctioned: boolean = false;
  @Input() isSold: boolean = false;
  protected unikoServiceTypesEnum = UnikoServiceTypes;
  protected defaultServices = defaultServices
  protected auctionServices = auctionServices
  constructor(private _router: Router) {

  }

  ngOnInit() {
    // TODO: Implement Swiper
    // FIX: Swiper initializes before the DOM because of transloco directive
    var swiper = new Swiper(".mySwiper", {});
  }
}
